// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2z-1";
export var rateTableServiceLevelDropdown = "_2z-3";
export var rateTableTypeDropdown = "_2z-0";
export var rateTableValueModeDropdown = "_2z-2";